// 📄 components/StepConfirmJob.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { ConfirmationFormData } from '../../../../../services/commerce/integrationService';

interface StepConfirmJobProps {
  jobName: string;
  jobVariant: string;
  jobStatus: string;
  onChange: (field: keyof ConfirmationFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepConfirmJob({ jobName, jobVariant, jobStatus, onChange, isInvalid }: StepConfirmJobProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">SM36 / SM37</span>
          <span>SAP Menu → Tools → CCMS → Jobs → Job Definition</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">4. Schedule Background Job</h3>
        <p className="text-sm text-gray-400">
          Programa el job periódico que procesa los IDocs entrantes de confirmación de orden.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Programa (Job) <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={jobName}
            onChange={(e) => onChange('jobName', e.target.value.toUpperCase())}
            placeholder="ARBCIG_INBOUND_IDOC_SUR"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
              isInvalid && !jobName ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Variante</label>
          <input
            type="text"
            value={jobVariant}
            onChange={(e) => onChange('jobVariant', e.target.value.toUpperCase())}
            placeholder="ej. ZVAR_CONFIRM"
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Estado del Job</label>
          <select
            value={jobStatus}
            onChange={(e) => onChange('jobStatus', e.target.value)}
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm text-white focus:outline-none focus:border-blue-500"
          >
            <option value="Pendiente">Pendiente de programar</option>
            <option value="Programado">Programado (Released)</option>
            <option value="Activo">Activo / Periódico</option>
          </select>
        </div>
      </div>

      <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 text-yellow-400 flex gap-3 text-sm">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Frecuencia recomendada</p>
          <p className="text-xs text-yellow-500/80 mt-0.5">
            Programa este job con una periodicidad corta (ej. cada 5-10 minutos) para evitar retrasos en el procesamiento de confirmaciones entrantes.
          </p>
        </div>
      </div>
    </div>
  );
}
